import {
    resetLongDescription,
    setLongDescription as setLongDescriptionReducer,
    setLongDescriptionFromDraft as setLongDescriptionFromDraftReducer
} from 'tradera/apps/syi/state/reducers/long-description';
import draftActions from './draft-actions';
import type { AppDispatch, GetState } from 'tradera/state/configure-store';
import { selectLongDescription } from 'tradera/apps/syi/state/selectors/syi';

export const setLongDescription =
    (longDescription: string) => (dispatch: AppDispatch) => {
        dispatch(setLongDescriptionReducer(longDescription));
        dispatch(draftActions.updateDraftCanBeResumed());
    };

export const prependLongDescription =
    (longDescription: string) =>
    (dispatch: AppDispatch, getState: GetState) => {
        const currentLongDescription = selectLongDescription(getState());
        const newLongDescription = `${longDescription}\n\n${currentLongDescription}`;
        // Needs to be FromDraft, otherwise the update will not be shown
        // in the redactor-controlled textarea.
        dispatch(setLongDescriptionFromDraftReducer(newLongDescription));
        dispatch(draftActions.updateDraftCanBeResumed());
    };

export const setLongDescriptionFromDraft =
    (longDescription: string) => (dispatch: AppDispatch) => {
        dispatch(setLongDescriptionFromDraftReducer(longDescription));
        dispatch(draftActions.updateDraftCanBeResumed());
    };

export const reset = () => (dispatch: AppDispatch) => {
    dispatch(resetLongDescription());
    dispatch(draftActions.updateDraftCanBeResumed());
};
